import React, { useState } from "react";
import toast from "react-hot-toast";
import "../../styles/DashboardHome.css";
import {
  downloadIsoEvidencePackExcelApi,
  downloadIsoEvidencePackPdfApi,
} from "../../lib/api";

function triggerDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
}

export default function ISOEvidencePacks() {
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [downloadingPdf, setDownloadingPdf] = useState(false);

  const onDownloadExcel = async () => {
    try {
      setDownloadingExcel(true);
      const blob = await downloadIsoEvidencePackExcelApi();
      triggerDownload(blob, "iso14001_evidence_pack.xlsx");
      toast.success("ISO evidence pack (Excel) downloaded");
    } catch (err) {
      toast.error(err?.message || "Failed to download Excel evidence pack");
    } finally {
      setDownloadingExcel(false);
    }
  };

  const onDownloadPdf = async () => {
    try {
      setDownloadingPdf(true);
      const blob = await downloadIsoEvidencePackPdfApi();
      triggerDownload(blob, "iso14001_evidence_pack.pdf");
      toast.success("ISO evidence pack (PDF) downloaded");
    } catch (err) {
      toast.error(err?.message || "Failed to download PDF evidence pack");
    } finally {
      setDownloadingPdf(false);
    }
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <div>
          <h1>ISO Evidence Packs</h1>
          <p className="subtitle">Export clause-ready evidence packs for audits and management review.</p>
        </div>
      </div>

      <div className="card settings-card">
        <div className="settings-header">
          <h3>Export Options</h3>
          <span className="kpi-sub">Includes clause groupings, statuses, owners, due dates, evidence references, and the approved Environmental Context record</span>
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button className="btn-primary" onClick={onDownloadExcel} disabled={downloadingExcel || downloadingPdf}>
            {downloadingExcel ? "Preparing Excel..." : "Download Excel Pack"}
          </button>
          <button className="btn-secondary" onClick={onDownloadPdf} disabled={downloadingPdf || downloadingExcel}>
            {downloadingPdf ? "Preparing PDF..." : "Download PDF Pack"}
          </button>
        </div>
      </div>
    </div>
  );
}
